module.exports = __webpack_public_path__ + "media/svg/icon_not_fit_purple-32238ef5.svg";